import { formatRepoFiltersToApiFilters } from '@webapp/core/utils/repositories/formatRepoFiltersToApiFilters'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type RepoStandardResponse } from '@webapp/infrastructure/interfaces/repositories/RepoStandardResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type TaxConstructor } from '@webapp/platform/finance'
import { type ITaxRepository } from '@webapp/platform/finance/business-logic/interfaces/ITaxRepository'
import { mapTaxApiModel } from '../../mappers/mapTaxApiModel'
import { type GetTaxesResponse } from '../../types/GetTaxesResponse'
import { type GetTaxResponse } from '../../types/GetTaxResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class TaxRepository implements ITaxRepository {
  constructor(private readonly deps: Dependency) {}

  async getTaxes(
    params?: RepoFilterParams
  ): Promise<RepoPaginatedResponse<TaxConstructor>> {
    const res = await this.deps.httpClient.get<GetTaxesResponse>(
      `/api/v3/tax/`,
      {
        params: {
          is_active: true,
          order_by: 'name',
          ...formatRepoFiltersToApiFilters(params),
        },
      }
    )

    const taxes = res.data.data || []
    const metadata = res.data.metadata

    return {
      data: taxes.map(mapTaxApiModel),
      pagination: {
        count: metadata?.pagination.count || 0,
        page: metadata?.pagination.current_page || 0,
        pageSize: metadata?.pagination.page_size || 0,
        numPages: metadata?.pagination.num_pages || 0,
      },
    }
  }

  async getTax(id: number): Promise<RepoStandardResponse<TaxConstructor>> {
    const res = await this.deps.httpClient.get<GetTaxResponse>(
      `/api/v3/tax/${id}/`
    )

    const data = res.data.data

    return {
      data: mapTaxApiModel(data),
    }
  }
}
